<ng-container *ngIf="adminHubLinks$ | async as adminHubLinks">
  <app-navigation-bar [topNavigationLinks]="adminHubLinks"></app-navigation-bar>
</ng-container>
